import React from 'react';
import { useTable } from 'react-table';
import { PropTypes } from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { useContext } from 'react';
import LanguageContext from '../../../contexts/languageContext';

const styles = makeStyles({
    container: {
        background: '#fff',
        marginTop: '25px',
        marginBottom: '-40px',
        padding: '24px 40px 24px 40px',
        borderRadius: '8px',
        minHeight: 'calc(100vh - 170px)'
    },
    headerContainer: {
        background: '#fff',
        position: 'sticky',
        top: '-60px'
        // paddingTop: '24px'
    },
    tableContainer: {
        overflowX: 'auto'
    },
    table: ({ rtl }) => ({
        textAlign: rtl ? 'right' : 'left',
        borderCollapse: 'collapse',
        width: '100%',
        direction: rtl ? 'rtl' : 'ltr',
        '& td,th': {
            textAlign: rtl ? 'right' : 'left',
            padding: '15px',
            minWidth: '200px'
        }
    }),
    header: {
        borderBottom: 'solid 1.5px rgba(206, 210, 214, 0.8)'
    },
    row: {
        borderRadius: '4px',
        '&:nth-child(odd)': {
            background: '#e8ecf2'
        },
        '& td:first-child': {
            borderRadius: ({ rtl }) => (rtl ? '0 4px 4px 0' : '4px 0 0 4px')
        },
        '& td:last-child': {
            borderRadius: ({ rtl }) => (rtl ? '4px 0 0 4px' : '0 4px 4px 0')
        }
    },
    loadingContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'calc(100vh - 300px)'
    },
    notExistContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(100vh - 200px)',
        '& span': {
            fontSize: '14px',
            fontWeight: 'normal'
        }
    }
});

const ResultTable = ({ data, columns }) => {
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });

    const { getTableProps, getTableBodyProps, headers, rows, prepareRow } = useTable({
        columns,
        data
    });

    return (
        <table {...getTableProps()} className={classes.table}>
            <thead className={classes.header}>
                {headers?.map((column, index) => (
                    <th key={index} {...column.getHeaderProps()}>
                        {column?.render('Header')}
                    </th>
                ))}
            </thead>
            <tbody {...getTableBodyProps()}>
                {rows?.map((row, i) => {
                    prepareRow(row);
                    return (
                        <tr {...row.getRowProps()} key={i} className={classes.row}>
                            {row?.cells?.map((cell, index) => {
                                return (
                                    <td
                                        {...cell.getCellProps()}
                                        key={index}
                                        data-testid="searchResult"
                                    >
                                        {cell.value ?? '-'}
                                    </td>
                                );
                            })}
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};
ResultTable.propTypes = {
    data: PropTypes.array,
    columns: PropTypes.array
};
export default ResultTable;
